export const isProMemberModalVisible = state => state?.proMember?.modal
